import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { FriendInfo, GroupListItem } from '@/api/types';
import { GroupDetailsPanelType } from '@/pages/main/contacts/_components/group/GroupDetail';

// 主页面
export enum MainPageType {
  CHAT = 'chat',
  CONTACTS = 'contacts',
  SETTINGS = 'settings'
}

// 联系人分组类型
export enum ContactPageTab {
  FRIENDS = 'friends',
  GROUPS = 'groups'
}

interface PageDataState {

  mainPageType: MainPageType;

  // 群组页面当前激活的标签
  groupActiveTab: ContactPageTab;
  groupSelectedFriend: FriendInfo | null;
  groupSelectedGroup: GroupListItem | null;
  groupDetailsPanelType: GroupDetailsPanelType;

  setMainPageMenu: (mainPageMenu: MainPageType) => void;

  setGroupActiveTab: (groupActiveTab: ContactPageTab) => void;
  setGroupSelectedFriend: (groupSelectedFriend: FriendInfo | null) => void;
  setGroupSelectedGroup: (groupSelectedGroup: GroupListItem | null) => void;
  setGroupDetailsPanelType: (groupDetailsPanelType: GroupDetailsPanelType) => void;
}

/**
 * 页面间数据的传递
 * 管理页面间数据的传递
 */
export const usePageDataStore = create<PageDataState>()(
  subscribeWithSelector((set, _) => ({

    mainPageType: MainPageType.CHAT,

    groupActiveTab: ContactPageTab.FRIENDS,
    groupSelectedFriend: null,
    groupSelectedGroup: null,
    groupDetailsPanelType: GroupDetailsPanelType.DETAIL,

    setMainPageMenu: (mainPageMenu: MainPageType) => set({ mainPageType: mainPageMenu }),

    setGroupActiveTab: (groupActiveTab: ContactPageTab) => set({ groupActiveTab }),
    setGroupSelectedFriend: (groupSelectedFriend: FriendInfo | null) => set({ groupSelectedFriend }),
    setGroupSelectedGroup: (groupSelectedGroup: GroupListItem | null) => set({ groupSelectedGroup }),
    setGroupDetailsPanelType: (groupDetailsPanelType: GroupDetailsPanelType) => set({ groupDetailsPanelType })

  }))
);
